export const EMOJI_BUTTON_ANIMATION = {
  initial: { scale: 1 },
  whileHover: {
    scale: 1.25,
    transition: {
      type: 'spring' as const,
      stiffness: 400,
      damping: 30,
      mass: 0.8,
    },
  },
  whileTap: { scale: 0.95 },
  style: {
    transformOrigin: 'center' as const,
    backfaceVisibility: 'hidden' as const,
  },
};
